export default __webpack_public_path__ + "static/media/img01.804c6716.png";